export var BlobMeta;
(function (BlobMeta) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/echo/blob.proto}
     */
    let State;
    (function (State) {
        State[State["PARTIALLY_PRESENT"] = 0] = "PARTIALLY_PRESENT";
        State[State["FULLY_PRESENT"] = 1] = "FULLY_PRESENT";
    })(State = BlobMeta.State || (BlobMeta.State = {}));
})(BlobMeta || (BlobMeta = {}));
//# sourceMappingURL=blob.js.map